<template>
  <b-card>
    <div class="d-flex justify-content-between flex-wrap mb-2">
      <b-form
        class="d-flex align-items-center "
        @submit.prevent="onSearch"
      >
        <b-form-input v-model.trim="search" />
        <b-button variant="primary" class="ml-sm-1 mt-sm-0 ml-50" type="submit">
          جستجو
        </b-button>
      </b-form>
      <b-button class="my-1" variant="outline-danger" @click="forgives">
        بخشش موارد انتخاب شده
      </b-button>
    </div>
    <data-table :fields="fields" :items="penalties" :loading="loading">
      <template #selectuser="{ data }">
        <b-form-checkbox
          v-if="data.item.status == 0"
          v-model="penaltiesData"
          :value="data.item.id"
        ></b-form-checkbox>
      </template>
      <template #id="{ data }">
        {{ data.item.id }}
      </template>
      <template #user="{ data }">
        <span style="white-space:nowrap;"> 
        {{ data.item.user.first_name + " " + data.item.user.last_name }}
        </span>
      </template>
      <template #created_at="{ data }">
        {{ calcDate(data.item.created_at) || "-" }}
      </template>
      <template #payed_at="{ data }">
        {{ calcDate(data.item.payed_at) || "-" }}
      </template>
      <template #amount="{ data }">
        <small class="text-success"
          >{{ numberWithCommas(data.item.amount) }} تومان</small
        >
      </template>
      <template #rebate="{ data }">
        <small class="text-danger"
          >{{ numberWithCommas(data.item.rebate) }} تومان
        </small>
      </template>
      <template #detail="{ data }">
        <div>
          <div style="white-space: nowrap">
            دوره : {{ data.item.course.name }}
          </div>
          <div style="white-space: nowrap" class="my-50">
            جلسه : {{ data.item.session.name }}
          </div>
          <div style="white-space: nowrap">
            تمرین : {{ data.item.exercise.title }}
          </div>
        </div>
      </template>
      <template #status="{ data }">
        <b-badge
          :variant="
            data.item.status == 0
              ? 'info'
              : data.item.status == 1
              ? 'success'
              : 'warning'
          "
          >{{
            data.item.status == 0
              ? "در انتظار پرداخت"
              : data.item.status == 1
              ? "پرداخت شده"
              : "بخشیده شده"
          }}
        </b-badge>
      </template>
      <template #actions="{ data }">
        <!-- <b-button
          size="sm"
          v-if="data.item.status == 0"
          variant="flat-success"
          @click="checkout(data.item)"
          >پرداخت</b-button
        > -->
        <b-button
          size="sm"
          v-if="data.item.status == 0"
          variant="flat-info"
          @click="forgive(data.item)"
          >بخشش</b-button
        >
        <b-button
          size="sm"
          variant="flat-warning"
          @click="
            penalty = data.item;
            visible = true;
            rebate = '';
          "
          v-if="data.item.status == 0"
          >تخفیف</b-button
        >
      </template>
    </data-table>

    <div
      class="w-100 d-flex flex-wrap justify-content-between align-items-center"
    >
      <div class="col-md-3 pl-0">
        <b-form-checkbox v-model="selectAll" class="ml-2">
          انتخاب همه</b-form-checkbox
        >
      </div>
      <div class="col-md-6 d-flex justify-content-md-center align-items-center">
        <b-pagination
          v-model="currentPage"
          :total-rows="pagination.total"
          :per-page="pagination.per_page"
          size="md"
          class="my-2 d-flex justify-content-center"
        ></b-pagination>
      </div>
      <b-form
        @submit.prevent="goTo"
        class="d-flex col-md-3 align-items-center justify-content-md-end pr-0"
      >
        <div>
          <b-button type="submit" size="sm" variant="primary"
            >رفتن به
          </b-button>
        </div>
        <b-form-group label-for="to-page" class="w-50 ml-50 mb-0">
          <b-form-input
            id="to-page"
            type="number"
            size="sm"
            :max="pagination.total_pages"
            min="1"
            v-model="choosenPage"
          />
        </b-form-group>
      </b-form>
    </div>
    <b-modal v-model="visible" hide-footer size="sm" centered>
      <validation-observer ref="courseForm" #default="{ invalid }">
        <b-form @submit.prevent="makeRebate">
          <b-form-group label=" تخفیف (تومان)" label-for="rebate" class="my-1">
            <validation-provider
              #default="{ errors }"
              name="rebate"
              vid="rebate"
              rules="required"
            >
              <b-form-input
                autocomplete="on"
                id="rebate"
                v-model="rebate"
                class="mb-1"
                type="number"
                min="0"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
          <b-button
            variant="primary"
            class="mb-75"
            block
            type="submit"
            :disabled="invalid"
          >
            اعمال تخفیف
          </b-button>
        </b-form>
      </validation-observer>
    </b-modal>
    <loader :loading="loader" />
  </b-card>
</template>
<script>
import {
  BButton,
  BModal,
  VBModal,
  BBadge,
  BPagination,
  BLink,
  BCard,
  BAvatar,
  BFormCheckbox,
  BForm,
  BFormInput,
  BFormGroup,
} from "bootstrap-vue";
import DataTable from "@/@core/components/data-table/DataTable.vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import Loader from "@core/components/loader/Loader.vue";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required } from "@validations";

export default {
  components: {
    DataTable,
    BButton,
    BCard,
    VBModal,
    BBadge,
    BPagination,
    BLink,
    BAvatar,
    BFormCheckbox,
    BModal,
    BForm,
    BFormInput,
    Loader,
    ValidationProvider,
    ValidationObserver,
    BFormGroup,
  },
  directives: {
    "b-modal": VBModal,
  },
  data() {
    return {
      choosenPage: 1,

      required,
      penalties: [],
      search: "",
      loading: false,
      selectAll: false,
      penaltiesData: [],
      url: "/panel/penalties",
      currentPage: 1,
      pagination: {},
      visible: false,
      loader: false,
      penalty: {},
      rebate: "",
      fields: [
        { key: "selectuser", label: "" },
        { key: "id", label: "شناسه" },
        { key: "user", label: "نام کاربر" },
        { key: "created_at", label: "تاریخ جریمه" },
        { key: "amount", label: "مبلغ جریمه" },
        { key: "rebate", label: "مبلغ تخفیف" },
        { key: "detail", label: "شرح" },
        { key: "payed_at", label: "تاریخ پرداخت" },
        { key: "status", label: "وضعیت" },
        { key: "actions", label: "عملیات" },
      ],
    };
  },
  watch: {
    selectAll: {
      handler(val) {
        val
          ? (this.penaltiesData = this.penalties.map((user) => user.id))
          : (this.penaltiesData = []);
      },
      immediate: true,
    },
    penaltiesData: {
      handler(val) {
        val.length == this.penalties.length && (this.selectAll = true);
        val.length == 0 && (this.selectAll = false);
      },
      deep: true,
    },
    $route: {
      handler(val) {
        this.getPenalties();
      },
      immediate: true,
      deep: true,
    },
    currentPage(val) {
      this.choosenPage = val;
      if (val != this.$route.query.page) {
        this.$router.push({
          name: "penalties",
          query: {
            ...this.$route.query,
            page: val,
          },
        });
      }
    },
    search(val) {
      if (!val && this.$route.query.key) {
        this.$router.push({
          name: "penalties",
        });
      }
    },
  },
  async created() {
     if (this.$route.query.key) {
      this.$router.push({
        name: "penalties",
      });
    }
    if (this.$route.query && this.$route.query.status) {
      await Object.keys(this.penaltiestatus).map((key) => {
        this.penaltiestatus[key] = this.$route.query[key];
      });
      this.visible = true;
    }
  },

  methods: {
    goTo() {
      this.currentPage = this.choosenPage;
    },
    async onSearch() {
      if (this.search) {
        this.$router.push({
          name: "penalties",
          query: {
            key: this.search,
          },
        });
      }
    },
    async checkout(item) {
      this.loader = true;
      try {
        const { data } = await this.$http.post("/panel/invoices", {
          items: [
            {
              model: {
                id: item.id,
                type: "penalty",
              },
            },
          ],
        });
        this.loader = false;

        this.$router.push({
          name: "checkout",
          query: {
            invoice_id: data.data.id,
          },
        });
      } catch (err) {
        this.loader = false;
        this.$toast(
          {
            component: ToastificationContent,
            props: {
              title: `مشکلی پیش آمده است.`,
              icon: "InfoIcon",
              variant: "danger",
            },
          },
          { position: "bottom-right" }
        );
      }
    },
    forgives() {
      if (this.penaltiesData.length) {
        this.$bvModal
          .msgBoxConfirm("آیا میخواهید جریمه های انتخاب شده بخشیده شوند ؟", {
            size: "sm",
            bodyClass: "h5 my-2",
            okVariant: "primary",
            okTitle: "بله",
            cancelTitle: "خیر",
            cancelVariant: "outline-secondary",
            hideHeaderClose: false,
            centered: true,
          })
          .then(async (value) => {
            if (value) {
              this.loading = true;
              try {
                await new Promise((resolve, reject) => {
                  this.penaltiesData.map(async (penalty, index) => {
                    await this.$http.put(this.url + `/${penalty}`, {
                      status: 2,
                    });
                    if (index + 1 == this.penaltiesData.length) {
                      resolve();
                    }
                  });
                });
                this.penaltiesData = [];
                await this.getPenalties();
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: "جریمه ها با موفقیت بخشیده شدند.",
                    icon: "EditIcon",
                    variant: "success",
                  },
                });
              } catch (err) {
                this.$toast(
                  {
                    component: ToastificationContent,
                    props: {
                      title: "مشکلی پیش آمده است",
                      icon: "InfoIcon",
                      variant: "danger",
                    },
                  },
                  { position: "bottom-right" }
                );
              }
              this.loading = false;
            }
          });
      } else {
        this.$toast(
          {
            component: ToastificationContent,
            props: {
              title: "کاربری انتخاب نشده است",
              icon: "InfoIcon",
              variant: "danger",
            },
          },
          { position: "bottom-right" }
        );
      }
    },
    async forgive(item) {
      this.$bvModal
        .msgBoxConfirm("آیا میخواهید جریمه این کاربر بخشیده شود ؟", {
          size: "sm",
          bodyClass: "h5 my-2",
          okVariant: "primary",
          okTitle: "بله",
          cancelTitle: "خیر",
          cancelVariant: "outline-secondary",
          hideHeaderClose: false,
          centered: true,
        })
        .then(async (value) => {
          if (value) {
            this.loading = true;
            try {
              const { data } = await this.$http.put(this.url + `/${item.id}`, {
                status: 2,
              });
              await this.getPenalties();
              this.$toast(
                {
                  component: ToastificationContent,
                  props: {
                    title: `تغییر شما با موفقیت ثبت شد.`,
                    icon: "CoffeeIcon",
                    variant: "success",
                  },
                },
                { position: "bottom-right" }
              );
            } catch (err) {}
            this.loading = false;
          }
        });
    },
    async makeRebate() {
      this.loading = true;
      try {
        const { data } = await this.$http.put(
          this.url + `/${this.penalty.id}`,
          {
            rebate: this.rebate,
          }
        );
        this.visible = false;
        await this.getPenalties();
        this.$toast(
          {
            component: ToastificationContent,
            props: {
              title: `تغییر شما با موفقیت ثبت شد.`,
              icon: "CoffeeIcon",
              variant: "success",
            },
          },
          { position: "bottom-right" }
        );
      } catch (err) {}
      this.loading = false;
    },
    async getPenalties() {
      this.loading = true;
      try {
        const params = {
          per_page: 8,
          ...this.$route.query,
          includes: ["transactions", "exercise", "user", "course", "session"],
        };
        const { data } = await this.$http.get(this.url, {
          params,
        });
        this.penalties = data.data.penalties;
        this.pagination = data.data.meta.pagination;
        this.currentPage = await this.pagination.current_page;
      } catch (err) {}
      this.loading = false;
    },
  },
};
</script>
